export default __webpack_public_path__ + "static/media/Focus.af327029.png";